import { createContext} from "react";

const SnackbarContext = createContext();

export default SnackbarContext;
